var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { Button, IconButton, InputAdornment, Menu, MenuItem, Tooltip, } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { Calendar as RCalendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useContextMenu } from 'react-contexify';
import { TopLabeledTextField } from '../../..';
import { MomentTimeZOnes } from '../../../commons/assets/TimeZones';
import { CustomTextField } from '../SchedulerMainView.Styles';
import { CalendarWrapper, FieldWrapper, Wrapper } from './Calendar.Styles';
import { CalendarToolBar } from './CalendarToolBar';
import { ContextMenu } from './ContextMenu';
import { CustomEvent } from './CustomEvent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { isBaseURLAll, set_config_baseURL, } from '../../../../api/utils';
var MENUID = 'myeventcontextmenu';
var show = useContextMenu({
    id: MENUID
}).show;
export var Calendar = function (_a) {
    var selectedAccount = _a.selectedAccount, handleSideBar = _a.handleSideBar, openSidebar = _a.openSidebar, scheduleEvents = _a.scheduleEvents, dialerDefaults = _a.dialerDefaults, onEnable = _a.onEnable, onEdit = _a.onEdit, onView = _a.onView, onCopy = _a.onCopy, campaigns = _a.campaigns, campaignGroups = _a.campaignGroups, onTimeZoneChange = _a.onTimeZoneChange, schedulesBetweenTimes = _a.schedulesBetweenTimes, getSchedulesBetweenTimes = _a.getSchedulesBetweenTimes, onRangeChange = _a.onRangeChange, onHolidayEdit = _a.onHolidayEdit, onExport = _a.onExport;
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    // tz.tz.setDefault('America/New_York');
    var _b = useState(momentLocalizer(moment)), localizer = _b[0], setLocalizer = _b[1];
    var _c = useState([]), events = _c[0], setEvents = _c[1];
    var _d = useState(moment.tz.guess()), timeZone = _d[0], setTimeZone = _d[1];
    var _f = useState({
        start: new Date(y, m, 1),
        end: new Date(y, m + 1, 6)
    }), dateRange = _f[0], setDateRange = _f[1];
    var _g = useState(null), filterAnchor = _g[0], setFilterAnchor = _g[1];
    var _h = useState('Schedule Name'), filterName = _h[0], setFilterName = _h[1];
    var _j = useState(''), filterTarget = _j[0], setFilterTarget = _j[1];
    var _k = useState(null), sEvent = _k[0], setSEvent = _k[1];
    var _l = useState(false), openDialog = _l[0], setOpenDialog = _l[1];
    var _m = useState(), reasonID = _m[0], setReasonID = _m[1];
    useEffect(function () {
        var events = scheduleEvents.schedules.reduce(function (acc, val) {
            var _a;
            var schedule = val.schedule;
            var configTimeZone = val.scheduleTimezone;
            var occurrenceType = ((_a = schedule.Occurrence) === null || _a === void 0 ? void 0 : _a.Single) ? 'single' : 'series';
            var _events = val.occurrences.map(function (e) {
                return {
                    id: Date.now() + Math.random(),
                    data_id: schedule.id,
                    title: schedule.ScheduleName,
                    isHoliday: false,
                    isEnabled: !(e === null || e === void 0 ? void 0 : e.disabled),
                    disabledReason: e === null || e === void 0 ? void 0 : e.disabledReason,
                    disablingEntityName: e === null || e === void 0 ? void 0 : e.disablingEntityName,
                    disabledOccurrence: !!((e === null || e === void 0 ? void 0 : e.disabled) && !schedule.Disabled),
                    campaignId: schedule.CampaignId,
                    allDay: false,
                    start: new Date(e.start),
                    end: new Date(e.end),
                    occurrenceType: occurrenceType,
                    configTimeZone: configTimeZone,
                    timeZone: timeZone,
                    status: e.status,
                    prjacc: val.prjacc
                };
            });
            return acc.concat(_events);
        }, []);
        var holidays = scheduleEvents.holidays.reduce(function (acc, val) {
            var holiday = val.holiday;
            var configTimeZone = dialerDefaults.ScheduleTimezone;
            var occurrenceType = 'single';
            var _events = val.times.map(function (e) {
                return {
                    id: Date.now() + Math.random(),
                    data_id: holiday.id,
                    title: holiday.HolidayName,
                    isHoliday: true,
                    isEnabled: true,
                    disabledOccurrence: false,
                    campaignId: '',
                    allDay: true,
                    start: new Date(e.start),
                    end: new Date(e.end),
                    occurrenceType: occurrenceType,
                    configTimeZone: configTimeZone,
                    timeZone: timeZone,
                    status: e.status,
                    prjacc: val.prjacc
                };
            });
            return acc.concat(_events);
        }, []);
        setEvents(events.concat(holidays));
    }, [scheduleEvents, timeZone]);
    useEffect(function () {
        getSchedulesBetweenTimes(dateRange === null || dateRange === void 0 ? void 0 : dateRange.start, dateRange === null || dateRange === void 0 ? void 0 : dateRange.end);
        onRangeChange(dateRange);
    }, [dateRange, selectedAccount]);
    var handleHolidayView = function () {
        var holidays = events.filter(function (event) { return event.isHoliday === true; });
        // setEvents(holidays)
    };
    var handleFilterMenu = function (event) {
        setFilterAnchor(event.currentTarget);
    };
    var handleCloseFilter = function () {
        setFilterAnchor(null);
    };
    var eventFilter = function (filterMode) {
        var lowerTarget = filterTarget.toLowerCase();
        switch (filterMode) {
            case 'Schedule Name':
                return events.filter(function (event) {
                    var _a;
                    return ((_a = event.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'Campaign Name':
                return events.filter(function (event) {
                    var _a;
                    var eventCampaign = campaigns.find(function (camp) {
                        return camp && camp.id === event.campaignId;
                    });
                    return (((_a = eventCampaign === null || eventCampaign === void 0 ? void 0 : eventCampaign.CampaignName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !==
                        -1);
                });
            case 'Campaign Group':
                return events.filter(function (event) {
                    var _a;
                    var singleSchedule = scheduleEvents.schedules.find(function (sched) {
                        return sched && sched.schedule.id === event.data_id;
                    });
                    var singleGroup = campaignGroups.find(function (group) {
                        return group.id === (singleSchedule === null || singleSchedule === void 0 ? void 0 : singleSchedule.campaignGroupId);
                    });
                    return ((_a = singleGroup === null || singleGroup === void 0 ? void 0 : singleGroup.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'Holidays':
                return events.filter(function (event) {
                    return event.isHoliday === true;
                });
            default:
                return events;
        }
    };
    var handleTimeZoneChange = function (timezone) {
        setTimeZone(timezone);
        moment.tz.setDefault(timezone);
        setLocalizer(momentLocalizer(moment));
        onTimeZoneChange && onTimeZoneChange(timezone);
    };
    var holidayFilter = function (holidayStatus) {
        holidayStatus ? setFilterName('Holidays') : setFilterName('Schedule Name');
    };
    var changeDateRange = function (startDate, endDate) {
        var startRange = new Date(startDate.replace(/-/g, '/'));
        var endRange = new Date(endDate.replace(/-/g, '/'));
        startRange.setHours(0);
        startRange.setMinutes(0);
        startRange.setMinutes(0);
        endRange.setHours(23);
        endRange.setMinutes(59);
        endRange.setMinutes(59);
        if (startDate !== '' && endDate !== '') {
            setDateRange({ start: startRange, end: endRange });
        }
        if (startDate === '' && endDate !== '') {
            setDateRange({ start: dateRange.start, end: endRange });
        }
        if (endDate === '' && startDate !== '') {
            setDateRange({ start: startRange, end: dateRange.end });
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(CalendarWrapper, null,
            React.createElement(FieldWrapper, null,
                React.createElement(CustomTextField, { size: 'small', label: "Filter by " + filterName, placeholder: "Filter by " + filterName, variant: 'outlined', InputProps: {
                        endAdornment: (React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(Tooltip, { title: 'Change Filter Criteria', placement: 'top' },
                                React.createElement(IconButton, { onClick: handleFilterMenu },
                                    React.createElement(FilterListIcon, null)))))
                    }, onChange: function (e) { return setFilterTarget(e.target.value); } }),
                React.createElement(Menu, { id: 'filter-menu', open: Boolean(filterAnchor), keepMounted: true, anchorEl: filterAnchor, onClose: handleCloseFilter },
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Schedule Name');
                        } },
                        "Schedule Name",
                        ' '),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Campaign Name');
                        } }, "Campaign Name"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Campaign Group');
                        } }, "Campaign Group")),
                React.createElement(TopLabeledTextField, { value: timeZone, label: '', placeholder: 'Time Zone', select: true, width: 300, onChange: function (e) { return handleTimeZoneChange(e.target.value); } }, MomentTimeZOnes.map(function (tz) { return (React.createElement(MenuItem, { value: tz }, tz)); }))),
            React.createElement(RCalendar, { dayLayoutAlgorithm: 'no-overlap', eventPropGetter: function (event) {
                    var backgroundColor;
                    if (event.isHoliday) {
                        backgroundColor = 'rgba(179,96,55, 0.65)';
                    }
                    else if (!event.isEnabled) {
                        backgroundColor = 'rgba(211,211,211, 0.65)';
                    }
                    else if ((event === null || event === void 0 ? void 0 : event.status) === 'FINISHED') {
                        backgroundColor = 'rgba(111,63,137, 0.65)';
                    }
                    else if ((event === null || event === void 0 ? void 0 : event.status) === 'RUNNING') {
                        backgroundColor = 'rgba(0,87,184, 0.65)';
                    }
                    else
                        backgroundColor = 'rgba(0,173,239, 0.45)';
                    var newStyle = {
                        backgroundColor: backgroundColor,
                        color: 'black',
                        borderRadius: '0px'
                    };
                    return {
                        className: '',
                        style: newStyle
                    };
                }, views: {
                    month: true,
                    day: true,
                    work_week: true,
                    week: true,
                    agenda: true
                }, popup: true, localizer: localizer, defaultDate: new Date(), events: eventFilter(filterName), startAccessor: 'start', endAccessor: 'end', showMultiDayTimes: true, components: {
                    toolbar: function (t) { return (React.createElement(CalendarToolBar, __assign({}, t, { dateRange: dateRange, handleSideBar: function () { return handleSideBar(); }, openSidebar: openSidebar, holidayFilter: holidayFilter, handleHolidayView: handleHolidayView, changeDateRange: function (startDate, endDate) {
                            return changeDateRange(startDate, endDate);
                        }, setFilter: function (name) { return setFilterName(name); } }))); },
                    event: function (_e) { return React.createElement(CustomEvent, { event: _e }); }
                }, length: 31, onRangeChange: function (data, view) {
                    if (data.start) {
                        setDateRange({ start: data.start, end: data.end });
                    }
                    else if (data.length === 1) {
                        var startDay = data[0];
                        var copyDay = new Date(startDay.getTime());
                        copyDay.setHours(23);
                        copyDay.setMinutes(59);
                        copyDay.setSeconds(59);
                        setDateRange({ start: startDay, end: copyDay });
                    }
                    else {
                        var end = data[data.length - 1];
                        end.setHours(23);
                        end.setMinutes(59);
                        end.setSeconds(59);
                        setDateRange({ start: data[0], end: end });
                    }
                }, onSelectEvent: function (event, e) {
                    setSEvent(event);
                    show(e);
                } })),
        React.createElement(ContextMenu, { menuID: MENUID, event: sEvent, onEnable: function (data_id, date, type, enable, reason) {
                var sced = scheduleEvents.schedules.find(function (s) { return s.schedule.id === data_id; });
                if (isBaseURLAll() && sced.prjacc) {
                    set_config_baseURL(sced.prjacc.url);
                }
                if (!reason || reason.disabledReason === 'disabled') {
                    onEnable(data_id, date, type, enable, reason);
                }
                else {
                    setOpenDialog(true);
                    setReasonID({ id: data_id, reason: reason });
                }
            }, onEdit: function (data_id, data, type) { return onEdit(data_id, data, type); }, onView: function (data_id, data, type) { return onView(data_id, data, type); }, onCopy: function (data_id, data, type) { return onCopy(data_id, data, type); }, onHolidayEdit: function (data_id) {
                var holiday = scheduleEvents.holidays.find(function (h) { return h.holiday.id === data_id; });
                if (isBaseURLAll()) {
                    onHolidayEdit(__assign(__assign({}, holiday === null || holiday === void 0 ? void 0 : holiday.holiday), { prjacc: holiday === null || holiday === void 0 ? void 0 : holiday.prjacc }));
                }
                else {
                    onHolidayEdit(holiday === null || holiday === void 0 ? void 0 : holiday.holiday);
                }
            }, onExport: function (data_id) { return onExport(data_id); } }),
        React.createElement(Dialog, { open: openDialog, onClose: function () { return setOpenDialog(false); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, "Do you want to continue?"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Enabling this occurrence will result to transforming it into single occurring event, do you want to continue?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return setOpenDialog(false); }, color: 'primary' }, "Cancel"),
                React.createElement(Button, { onClick: function () {
                        if (reasonID) {
                            onEnable(reasonID.id, reasonID.reason.date, 'occurrence', true, reasonID.reason);
                            setOpenDialog(false);
                        }
                    }, color: 'primary', autoFocus: true }, "Yes")))));
};
//# sourceMappingURL=Calendar.js.map